<template>
    <v-container fill-height>
        <v-layout justify-center>
            <PlantForm :plantId="plantId"></PlantForm>
        </v-layout>
    </v-container>
</template>

<script>
    import { uuid } from 'vue-uuid';
    import PlantForm from '../components/detail/plant/PlantForm';

    export default {
        name: "Plant",
        components: {
            PlantForm
        },
        computed: {
            plantId() {
                let plantId = this.$route.params.plantId
                return plantId ? plantId : uuid.v4()
            }
        }
    };
</script>
